import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import Content from "@/features/profile/pages-content/UsersLogs-content/UsersLogs.content";

const UsersLogs: React.FC = () => {
    const theme = useTheme();
    const matchDownMd = useMediaQuery(theme.breakpoints.down("lg"));

    return (
        <PerfectScrollbar className="home-page-container">
            <Box>
                <Grid container rowSpacing={3} columnSpacing={3}>
                    {/* row 1 */}
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Content />
                    </Grid>
                </Grid>
            </Box>
        </PerfectScrollbar>
    );
};

export default UsersLogs;
